import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone, generateCircleDot } from '../utils'
import Loading from './Loading'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';
import NoData from './NoData';
import BacklinkDistributionByDAChart from './BacklinkDistributionByDAChart';


function NewBacklinks({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')
    const [selectedLinks, setSelectedLinks] = useState([])


    const [isLoading, setIsLoading] = useState(false)
    const [showInfo, setShowInfo] = useState(false);

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()


    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)
          setNoData(false)
          setData([])

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

            setIsLoading(true)
              fetch(`${base}/res`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'nbl',
                  url: url,
                  userId: user.id
                })
              }).then(res=> res.json()).then(data=> {
                setData(data)
                setIsLoading(false)
                dispatch(redNex(nx))
                updateAnalytics()
              })
            } else {
              if(url.trim() === '') setNoInput1(true)
            }
    }

    const toggleInfo = () => {
        setShowInfo(!showInfo);
    };

   
    const [noData, setNoData] = useState(false)

  
    useEffect(()=> {
      if(isLoading) {
        const timerId = setTimeout(() => {
          if(data.length === 0) {
            setNoData(true)
            setIsLoading(false)
          }
        }, 30000);
        return () => clearTimeout(timerId);
      }
    }, [isLoading])


    const selectLinks = (i) => {
      setSelectedLinks(prev => {
        if (prev.includes(i)) {
          return prev.filter(index => index !== i);
        } else {
          return [...prev, i];
        }
      });
    };


    const selectAll = () => {
      setSelectedLinks(prev => {
        if (prev.length === data.length) {
          return [];
        } else {
          return data.map((_, index) => index);
        }
      });
    };


    const exportToCSV = (selectedIndexes) => {
      // Define the CSV headers
      const headers = ['Rank', 'Page Title', 'Location', 'Anchor Text', 'Destination URL', 'Page Authority', 'Domain Authority', 'Found On'];
    
      // Filter the selected data based on the selected indexes
      const selectedData = selectedIndexes.map(index => data[index]);
    
      // Create the CSV rows
      const rows = selectedData.map(row => [
        row.rank,                      // Rank
        row.titleLocation.title,        // Page Title
        row.titleLocation.location,     // Location (in its own column)
        row.anchorDest.anchorText,      // Anchor Text
        row.anchorDest.dest,            // Destination URL
        row.pa,                         // Page Authority
        row.da,                         // Domain Authority
        row.found                       // Found On
      ]);
    
      // Combine headers and rows into a single CSV string
      const csvContent = [
        headers.join(','),              // Add headers
        ...rows.map(row => row.join(','))  // Add each row
      ].join('\n');                     // Join with newline characters
    
      // Create a Blob from the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
      // Create a link to trigger the download
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', 'selected_links.csv');
    
      // Append link to body, trigger download, then remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    
    


    const getHighestDA = () => {
      // Extract the DA values and convert them to numbers
      const daValues = data.map(item => parseInt(item.da, 10));
    
      // Find the highest DA value
      const highestDA = Math.max(...daValues);
    
      return highestDA;
    };


    const getLowestDA = () => {
      // Extract the DA values and convert them to numbers
      const daValues = data.map(item => parseInt(item.da, 10));
    
      // Find the lowest DA value
      const lowestDA = Math.min(...daValues);
    
      return lowestDA;
    };

   


  return (
    <NewBacklinksContainer>
            <NewBacklinksInputContainer>
            <div style={{display: 'flex', flexDirection: 'column'}}>
            <h2>
                New Backlinks
                {false && <button onClick={toggleInfo} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', outline: 'none' }}>
                    {showInfo ? <RemoveIcon style={{color: 'var(--bl-color)'}}/> : <AddIcon style={{color: 'var(--bl-color)'}}/>}
                </button>}
            </h2>
            {showInfo && (
                <HeaderSpan>
                    This tool tracks and reports newly acquired backlinks for your website, offering vital insights into your site's SEO health and potential traffic sources.
                </HeaderSpan>
            )}</div>
            <NewBacklinksInnerInputContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            
                
                {data.length !== 0 && !isLoading && !noData && <ChartContainer>
                  <h3>Backlink Distribution By Domain Authority</h3>
                  <BacklinkDistributionByDAChart data={data} />
                </ChartContainer>}
            </NewBacklinksInnerInputContainer>
        </NewBacklinksInputContainer>

        {data.length !== 0 && !isLoading && !noData && <OperationsContainer>
          <h4>Total Links <span>{data.length}</span></h4>
          <h4>Highest Domain Authority <span>{getHighestDA()}</span></h4>
          <h4>Lowest Domain Authority <span>{getLowestDA()}</span></h4>
          <button className='export_btn' onClick={()=> exportToCSV(selectedLinks)} style={{visibility: selectedLinks.length !== 0? 'visible': 'hidden'}}>Export to CSV</button>
        </OperationsContainer>}

        {data.length !== 0 && !isLoading && <NewBacklinksResContainer>
            <NewBacklinksRes style={{fontWeight: '400', fontSize: 'small'}}>
                <p className='checkbox' onClick={()=> selectAll()} style={{backgroundColor: (selectedLinks.length === data.length)? 'var(--bl-color': ''}}></p>
                <p style={{width: '400px', marginRight: '10px'}}>Page Title & Location</p>
                <p style={{width: '250px'}}>Anchor Text & Destination</p>
                <p style={{width: '130px'}}>Page Authority</p>
                <p style={{width: '130px'}}>Domain Authority</p>
                <p style={{width: '160px', marginLeft: 'auto'}}>Found On</p>
            </NewBacklinksRes>

            

            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            {data.map((nl, i) => {
                return (
                    <NewBacklinksRes style={{backgroundColor: selectedLinks.includes(i)? '#cefae6be': ''}}>
                        <p className='checkbox' onClick={()=> selectLinks(i)} style={{backgroundColor: selectedLinks.includes(i)? 'var(--bl-color)': ''}}></p>
                        <div style={{width: '400px', display: 'flex', flexDirection: 'column', marginRight: '30px', wordWrap: 'break-word'}}>
                            <p className='title'>{nl.titleLocation?.title}</p>
                            <p className='location_url' onClick={()=> window.open(nl.titleLocation.location, '_blank')}>{nl.titleLocation.location}</p>
                        </div>
                        <div style={{width: '250px', display: 'flex', flexDirection: 'column', wordWrap: 'break-word', marginRight: '20px'}}>
                            <p className='anchor_text'>{nl.anchorDest.anchorText}</p>
                            <p className='dest_url' onClick={()=> window.open(nl.anchorDest.dest, '_blank')}>{nl.anchorDest.dest}</p>
                        </div>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}>{generateCircleDot(10, nl.pa)}{nl.pa}</p>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}> {generateCircleDot(10, nl.da)}{nl.da}</p>
                        <p style={{width: '160px', marginLeft: 'auto'}}>{nl.found}</p>
                    </NewBacklinksRes>
                )
            })}</div>
        </NewBacklinksResContainer>}
        {isLoading && <Loading />}
        {noData && <NoData />}

        {data.length == 0 && !isLoading && !noData && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The New Backlinks Tool tracks and reports new backlinks that have recently been added to your website. 
            By keeping an eye on newly acquired backlinks, you can evaluate their quality and impact on your SEO strategy.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of your website</p>
          <p>2. Click "Get Data" to view a list of recent backlinks</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Regularly monitor new backlinks to ensure they are from reputable sources and contribute positively to your SEO</p>

        </Intro>}
    </NewBacklinksContainer>
  )
}

export default NewBacklinks


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const NewBacklinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`


const NewBacklinksInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--bl-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--bl-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--bl-color);
    color: white;
  }

  > div > button:hover {
    color: var(--bl-color);
    background-color: rgb(239, 239, 239);
  }
`


const NewBacklinksInnerInputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--bl-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const NewBacklinksResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const NewBacklinksRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;

    > p {
      font-family: 'Quicksand';
    }

    .checkbox {
      width: 15px;
      height: 15px;
      border: 1px solid lightgray;
      border-radius: 3px;
      margin-right: 10px;

      &:hover {
        cursor: pointer;
        background-color: #ebebeb;
      }
    }


    > div {
    > .title {
      font-size: 13px;
      font-weight: bold;
    }

    > .location_url {
      font-size: 13px;
      color: blue;
      cursor: pointer;
      transition: text-decoration 0.3s ease-in-out;
      width: fit-content;
      word-break: break-all;

      &:hover {
        text-decoration: underline;
      }
    }

    > .dest_url {
      font-size: 13px;
      color: blue;
      cursor: pointer;
      transition: text-decoration 0.3s ease-in-out;
      width: fit-content;

      &:hover {
        text-decoration: underline;
      }
    }

    > .anchor_text {
      font-size: small;
      font-weight: bold;
    }
  }
`

const HeaderSpan = styled.span`
    font-weight: 300;
    color: var(--bl-color);
    font-size: medium;

    opacity: 0;
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`


const OperationsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  z-index: 1000;
  align-items: center;
  padding-top: 5px;
  gap: 35px;


  > h4 {
    font-family: 'Quicksand';
    margin-left: 20px;
    color: white;
    font-weight: 300;

    > span {
      font-family: 'Quicksand';
    }
  }


  > .export_btn {
      padding: 6px 12px;
      border: none;
      background-color: var(--bl-color);
      cursor: pointer;
      transition: background-color 0.3s ease-in-out;
      color: white;
      border-radius: 3px;
      margin-left: auto;
      margin-right: 25px;
      margin-top: 10px;

      opacity: 0;
      animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

      &:hover {
        background-color: transparent;
        color: white;
      }
    }
`


const ChartContainer = styled.div`
  display: flex;
  width: 500px;
  position: absolute;
  top: 40px;
  right: 120px;
  height: 300px;
  flex-direction: column;

  > h3 {
    font-size: small;
    font-weight: 300;
    font-family: 'Quicksand';
  }
`